import { useMemo } from "react";
import { toast } from "@volca/ui/lib/toast";
import { getPayrollRosterApiErrorMessage } from "@/payroll/roster/api-errors";
import { useSaveWorkbookAccess } from "./query";
import type {
  AccessKeySetting,
  WorkbookAccessSettings,
  WorkingAccess,
} from "./types";
import { workingFromSettings } from "./utils";

export const useWorkbookAccessChanges = (
  businessId: string,
  settings: WorkbookAccessSettings,
) => {
  const working = useMemo(() => workingFromSettings(settings), [settings]);
  const save = useSaveWorkbookAccess(businessId);
  const saveWorking = async (working: WorkingAccess) => {
    try {
      await save.mutateAsync({ working, settings });
      return true;
    } catch (error) {
      toast.error(getPayrollRosterApiErrorMessage(error));
      return false;
    }
  };
  const saveKey = (setting: AccessKeySetting) =>
    saveWorking({
      ...working,
      keySettings: working.keySettings.map((existing) =>
        existing.key === setting.key ? setting : existing,
      ),
    });
  return { working, save, saveWorking, saveKey };
};
